<template>
    <div class="institute-page">
        <SiteHeader />

        <div class="header">
            <!-- 如果有具体的头部图片资源，可以取消注释并替换 src -->
            <!-- <img :src="headerImage" alt="Institute Header" class="header-image"> -->
        </div>

        <div class="content">
            <div class="left-intro">
                <h2>重庆市兰台档案研究院</h2>
                <div class="right-content">
                    <div v-html="introductionText"></div>
                </div>
            </div>
        </div>

        <SiteFooter />
    </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'

export default {
    name: 'InstitutePage',
    components: {
        SiteHeader,
        SiteFooter
    },
    data() {
        return {
            // headerImage: `${process.env.BASE_URL}images/institute-header.jpg`, 
            introductionText: `
                <p>重庆市兰台档案研究院为重庆市首家社科类民办非企业研究机构，属"3A级社会组织""全国先进社科类社会组织"，是西南地区唯一申报国家档案局重点实验室依托单位；全国首个档案专项职业能力开发、考核规范编制及题库建设和承接考核鉴定的单位；全国首个档案整理专项职业能力培训基地；重庆市档案局档案服务企业联系机制成员单位；全国首个档案文献修复专项职业能力开发单位；全国首个已完成档案数字化管理师S题库开发单位。</p>
                
                <p>研究院专注档案领域理论与应用研究，构建了以国家档案局、中国人民大学为指导单位，以头部企业、高校和行业协会共同搭建的研发、实验和实训基地的三层构架运营模式，形成了档案事业境界、产业的思路和企业的方法工作格局，按照档案业务项目化、档案服务产品化、档案融合产业化的工作思路，为各级党委政府部门和企事业单位科学决策提供档案支撑服务。目前，研究院与中国人民大学正在共建档案人才培养基地，在科研项目和档案产业发展等方面建立了全面合作。此外，研究院与重庆文理学院共建了档案数字技术现代产业学院。</p>
                
                <p>研究院响应国家档案事业从体系建设向能力建设转变的要求，围绕智库建设、项目实施、人才重塑三方面，目前已形成包括档案专业化培训、档案管理体系咨询、档案职称申报辅导、档案规范化整理、口述历史采集与编研、家庭档案系统与管理等九大业务板块，共四十九项精细化服务内容，致力于推动档案学科的实践创新与行业高质量发展。</p>
                
                <p>研究院致力于档案整理、档案数字化管理师、档案文献修复人才培养，开展了档案相关培训，包括开发了档案整理考核鉴定项目，档案数字化管理师培训项目。2026年3月30日，全国首期档案数字化管理师培训班在重庆市兰台档案研究院举办。研究院成立了重庆市兰数数据运营管理有限公司，并相继成立新疆、永川、安徽分公司，构建覆盖全国培训体系。</p>
                
                <p>未来，研究院将努力实现档案产业园、档案数字产业互联网、国家档案局重点实验室等目标，建设"应用研究—技术孵化—产业标准"全链条创新平台，建设成为国家级档案创新人才培养高地、档案科技研发与成果转化高地、档案产业生态构建与标准引领高地，服务于治国理政与文明传承的档案智库。</p>
            `
        }
    }
}
</script>

<style scoped>
.institute-page {
    min-height: 100vh;
    background-color: #f5f7fa;
    display: flex;
    flex-direction: column;
}

.header {
    width: 100%;
    /* 如果需要背景图或高度，可在此添加 */
    /* background: url(...) no-repeat center center; */
    /* height: 300px; */
}

.content {
    max-width: 1200px;
    margin: 40px auto;
    padding: 0 20px;
    flex: 1;
    width: 100%;
    box-sizing: border-box;
}

.left-intro {
    background: white;
    border-radius: 12px;
    padding: 40px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.left-intro h2 {
    color: #aa5f44;
    font-size: 28px;
    margin-bottom: 30px;
    font-weight: 600;
    border-bottom: 2px solid #ac6249;
    padding-bottom: 10px;
    display: inline-block;
}

.right-content {
    font-size: 16px;
    line-height: 1.8;
    color: #4a5568;
}

.right-content p {
    margin-bottom: 20px;
    text-align: justify;
}

.right-content p:last-child {
    margin-bottom: 0;
}

@media (max-width: 768px) {
    .content {
        margin: 20px auto;
        padding: 0 15px;
    }

    .left-intro {
        padding: 20px;
    }

    .left-intro h2 {
        font-size: 22px;
        margin-bottom: 20px;
    }

    .right-content {
        font-size: 15px;
    }
}
</style>